import React, { useEffect } from "react";
import ConnexionForm from "../ConnexionForm";
import SignupForm from "../SignupForm";
import ForgetPassword from "../ForgetPassword";
import VerificationModal from "../SignupForm/components/VerificationModal";
import getStyles from "./SignInSignUpContainer.styles";
import { Typography, Box } from "@mui/material";
import { ModalCard, Avatar } from "@dishopsaas/design-system";
import { useSignInSignUp } from "../../hooks/useSignInSignUp";
import type { SignUpData } from "../../1_types/signinTypes";
import CloseButton from "../CloseButton";
const SignInSignUpContainer: React.FC = () => {
  const {
    userSignupError,
    userConnectionError,
    resetPasswordError,
    signUp,
    showForgetPassword,
    name,
    handleUserConnection,
    handleUserSignUp,
    handleForgetPassword,
    handleFacebookOrGoogleSignIn,
    handleResetLogin,
    showVerificationModal,
    handleShowVerificationModal,
    email,
    logoUrl,
    handleShowForgetPassword,
  } = useSignInSignUp();

  useEffect(() => {
    handleResetLogin();
  }, [handleResetLogin]);

  const onSubmitConnection = (email: string, password: string) => {
    handleUserConnection(email, password);
  };
  const styles = getStyles();
  const onSubmitSignUp = (
    email: string,
    password: string,
    nom: string,
    prenom: string,
    telephone: string,
    phoneObj?: any,
    newsletter: boolean = false
  ) => {
    const signUpData: SignUpData = {
      email,
      password,
      nom,
      prenom,
      telephone,
      phoneObj,
      newsletter,
    };
    handleUserSignUp(signUpData);
  };

  const onSubmitForgetPassword = (email: string) => {
    handleForgetPassword(email);
  };

  const handleContinueToSignup = () => {
    handleShowVerificationModal(true);
  };

  const getTitle = () => {
    if (signUp) {
      return "INSCRIPTION";
    }
    return `BIENVENUE CHEZ ${name?.toUpperCase()}`;
  };

  const getSubtitle = () => {
    if (signUp) {
      return null;
    }
    return (
      "Créez un compte " + name + " en quelques secondes ou Connectez-vous"
    );
  };

  return (
    <div>
      <div>
        {!signUp && !showForgetPassword && (
          <Box>
            <Box style={styles.signInContainer}>
              <Avatar src={logoUrl} size="lg" shape="rounded" />
              <Box sx={{ gap: 1 }}>
                <Typography variant="h4" sx={styles.welcomeTitle}>
                  {getTitle()}
                </Typography>
                {getSubtitle() && (
                  <Typography variant="body2" sx={styles.welcomeSubtitle}>
                    {getSubtitle()}
                  </Typography>
                )}
              </Box>
            </Box>
            <ConnexionForm
              onSubmit={onSubmitConnection}
              facebookOrGoogleSignIn={handleFacebookOrGoogleSignIn}
              errorMessage={userConnectionError}
              onContinueToSignup={handleContinueToSignup}
            />
          </Box>
        )}

        {signUp && !showForgetPassword && (
          <div>
            <Box style={styles.boxContainer}>
              <Typography variant="h4" sx={styles.welcomeTitle}>
                {getTitle()}
              </Typography>
            </Box>
            <SignupForm
              onSubmit={onSubmitSignUp}
              errorMessage={userSignupError}
            />
          </div>
        )}

        <ModalCard
          open={showVerificationModal}
          onClose={() => handleShowVerificationModal(false)}
        >
          <VerificationModal
            email={email}
            onClose={() => handleShowVerificationModal(false)}
          />
        </ModalCard>

        <ModalCard
          sxModal={styles.container}
          maxWidth={440}
          open={!signUp && showForgetPassword}
          onClose={() => handleShowForgetPassword(false)}
        >
          <Box>
            <CloseButton
              sx={styles.close}
              onClick={() => {
                handleShowForgetPassword(false);
              }}
            ></CloseButton>
            <ForgetPassword
              onSubmit={onSubmitForgetPassword}
              errorMessage={resetPasswordError}
            />
          </Box>
        </ModalCard>
      </div>
    </div>
  );
};

export default SignInSignUpContainer;
